export default "<img width=\"100%\" height=\"100%\" alt=\"404 image star wars\" src=\"../../../assets/images/404.svg\">\r\n"